var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import { PureComponent, createRef } from 'react';
import { Event as UiBaseEvent } from '@ifeng-fe/ui_base';
import handleAd from '../utils/handleAd';
import { getColumnInfo, getCommentCount } from '../utils/api';
import { styleName } from '../utils/utils';
var Basic = /** @class */ (function (_super) {
    __extends(Basic, _super);
    function Basic(props) {
        var argu = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            argu[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArrays([props], argu)) || this;
        // 替换广告数据
        _this.insert = function (insertArr, replaceArr, adFn) {
            if (adFn && typeof adFn === 'function') {
                var content = _this.state.content;
                var infoData_1 = __spreadArrays(content);
                var refs_1 = [];
                insertArr.forEach(function (value, index, array) {
                    var ref = createRef();
                    refs_1.push({
                        index: value,
                        ref: ref
                    });
                    infoData_1.splice(value, 0, {
                        type: 'ad',
                        ref: ref
                    });
                });
                replaceArr.forEach(function (value, index, array) {
                    var ref = React.createRef();
                    refs_1.push({
                        index: value,
                        ref: ref
                    });
                    infoData_1.splice(value, 1, {
                        type: 'ad',
                        ref: ref
                    });
                });
                _this.setState({
                    content: infoData_1
                }, function () {
                    var dom = {};
                    for (var _i = 0, refs_2 = refs_1; _i < refs_2.length; _i++) {
                        var ref = refs_2[_i];
                        dom[ref.index] = ref.ref.current;
                    }
                    adFn(dom);
                });
            }
        };
        // 监听滚动加载
        _this.handleWindowScroll = function (event) {
            if (!_this.state.isLoading) {
                var scroll_1 = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                var old = _this.position;
                _this.position = scroll_1;
                // 判断滚动条位置
                if (old !== undefined && _this.position !== undefined && old >= scroll_1) {
                    return void 0;
                }
                var current = _this.listRef.current;
                if (current) {
                    var top_1 = current.offsetTop + current.clientHeight;
                    if (scroll_1 + (window.innerHeight || document.documentElement.clientHeight) >= top_1 - 50) {
                        _this.handleGetColumnInfoClick();
                    }
                }
            }
        };
        _this.lastItem = undefined; // 最后一条数据
        _this.position = undefined; // 记录滚动的位置
        _this.listRef = createRef();
        _this.countMap = {};
        return _this;
    }
    Basic.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.content !== prevState.oldContent) {
            return {
                oldContent: nextProps.content,
                content: nextProps.content
            };
        }
        return null;
    };
    // 获取广告
    Basic.prototype.getAd = function (ad) {
        return __awaiter(this, void 0, void 0, function () {
            var len, callback, event;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        len = this.state.content.length;
                        return [4 /*yield*/, handleAd(ad)];
                    case 1:
                        callback = _a.sent();
                        event = new UiBaseEvent();
                        callback && callback(ad.data, event, this.insert);
                        event.trigger('init', {
                            len: len < 20 ? len : 20,
                            index: 0
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    // 获取评论列表
    Basic.prototype.getCount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var urlArr, keys_1, noKeys, _a, countMapCache_1, content, key, item, cid, data, _b, err_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        urlArr = [];
                        keys_1 = [];
                        noKeys = [];
                        _a = this.state, countMapCache_1 = _a.countMapCache, content = _a.content;
                        if (!countMapCache_1) return [3 /*break*/, 4];
                        for (key in this.countMap) {
                            item = content[this.countMap[key]];
                            cid = item.commentUrl || item.guid;
                            if (cid) {
                                keys_1.push(key);
                                urlArr.push(cid);
                            }
                            else {
                                noKeys.push(key);
                            }
                        }
                        if (!(urlArr.length !== 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getCommentCount(urlArr)];
                    case 1:
                        _b = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _b = [];
                        _c.label = 3;
                    case 3:
                        data = _b;
                        data.forEach(function (value, index, array) {
                            countMapCache_1[keys_1[index]] = value.allcount || 0;
                        });
                        noKeys.forEach(function (value, index, array) {
                            countMapCache_1[value] = 0;
                        });
                        this.setState({
                            countMapCache: __assign({}, countMapCache_1)
                        });
                        _c.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_1 = _c.sent();
                        console.error(err_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    // 加载新数据流的评论
    Basic.prototype.countCallback = function () {
        this.getCount();
        if (this.props.isScrollLoadingData && this.state.isEnd) {
            this.unlistenerHandleWindowScroll();
        }
    };
    // 加载更多
    Basic.prototype.handleGetColumnInfoClick = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, newsTime, id, time, _b, columnId, urlId, dataTypeName, handleLoadingDataFunc, data, _c, err_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.setState({ isLoading: true });
                        if (!this.lastItem) return [3 /*break*/, 7];
                        _a = this.lastItem, newsTime = _a.newsTime, id = _a.id;
                        time = (newsTime ? (new Date(newsTime)) : (new Date())).getTime();
                        _b = this.props, columnId = _b.columnId, urlId = _b.urlId, dataTypeName = _b.dataTypeName, handleLoadingDataFunc = _b.handleLoadingDataFunc;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, , 7]);
                        if (!handleLoadingDataFunc) return [3 /*break*/, 3];
                        return [4 /*yield*/, handleLoadingDataFunc(this)];
                    case 2:
                        _c = _d.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, getColumnInfo(id, time, 20, columnId, dataTypeName, urlId)];
                    case 4:
                        _c = _d.sent();
                        _d.label = 5;
                    case 5:
                        data = (_c).data;
                        this.setState({
                            content: this.state.content.concat(data.newsstream),
                            isEnd: data.isEnd,
                            isLoading: false
                        }, this.countCallback);
                        return [3 /*break*/, 7];
                    case 6:
                        err_2 = _d.sent();
                        console.error(err_2);
                        this.setState({ isLoading: false });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    // 查看更多
    Basic.prototype.moreView = function () {
        var moreHref = this.props.moreHref;
        return this.state.isEnd ? (React.createElement("span", { className: styleName('basic-is-end') }, "\u5DF2\u663E\u793A\u5168\u90E8")) : (moreHref ? (React.createElement("a", { className: styleName('basic-more'), href: moreHref, target: "_blank" }, "\u67E5\u770B\u66F4\u591A")) : (React.createElement("a", { className: styleName('basic-more'), onClick: this.props.isScrollLoadingData ? undefined : this.handleGetColumnInfoClick.bind(this) }, "\u67E5\u770B\u66F4\u591A")));
    };
    return Basic;
}(PureComponent));
export default Basic;
